import { withInstall } from '@bigin/utils'

import Rate from './src/rate.vue'

export const BRate = withInstall(Rate)
export default BRate

export * from './src/rate'
